const colours = {
    grey: '#6b6c6f',
    offwhite: '#FFFEF7',
}

export default colours
